import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import './TalentCard.css';

const TalentCard = () => {
  const { id } = useParams(); // missionId
  const navigate = useNavigate();
  const [talents, setTalents] = useState([]);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const authToken = localStorage.getItem('authToken');
  const userId = localStorage.getItem('userId');
  const API_BASE = process.env.REACT_APP_API_BASE_URL;



  const fetchSuggestions = async () => {
    try {

      const res = await axios.get(`${API_BASE}/api/matching/suggestions/${id}`, {
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      });


      const filteredTalents = (res.data || []).filter(talent => {
        const match = talent.recruteur === userId || talent.recruteurId === userId;
        return match;
      });

      setTalents(filteredTalents);
    } catch (err) {
      console.error("💥 Erreur chargement talents suggérés :", err);
      setError("Erreur lors du chargement des suggestions.");
    }
  };

  const handleManualMatching = async () => {
    try {
      setLoading(true);
      setError('');
      setSuccessMessage('');


      const matchRes = await axios.get(`${API_BASE}/api/matching/match/${id}`, {
        headers: {
          Authorization: `Bearer ${authToken}`
        },
        params: { recruteurId: userId }
      });


      await fetchSuggestions();
      setSuccessMessage('🎯 Matching effectué avec succès !');
    } catch (err) {
      console.error("💥 Erreur lancement du matching manuel :", err);
      setError("Échec du matching manuel.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchSuggestions();
      handleManualMatching();
    }
  }, [id]);

  const topTalents = [...talents]
    .sort((a, b) => b.similarity - a.similarity)
    .slice(0, 3);

  return (
    <div className="talent-card">
      <h3>🎯 Talents suggérés</h3>

      <button className="matching-button" onClick={handleManualMatching} disabled={loading}>
        {loading ? 'Analyse en cours...' : 'Lancer le matching'}
      </button>

      {successMessage && <p className="success-msg">{successMessage}</p>}
      {error && <p className="error-msg">{error}</p>}

      {topTalents.length === 0 && !error && (
        <p className="no-talent">Aucun talent suggéré pour le moment.</p>
      )}

      <ul className="talent-list">
        {topTalents.map((talent, index) => (
          <li
            key={index}
            className="talent-item"
            onClick={() => navigate(`/Recruteur/talent-detail/${talent._id}`)}
            style={{ cursor: 'pointer' }}
          >
            <div className="talent-name">{talent.prenomCandidat} {talent.nomCandidat}</div>
            <div className="talent-score">✅ Score : {(talent.similarity * 100).toFixed(1)}%</div>
          </li>
        ))}
      </ul>

      {talents.length > 3 && (
        <button className="voir-tous-btn" onClick={() => navigate(`/missions/${id}/talents`)}>
          Voir tous les talents suggérés →
        </button>
      )}
    </div>
  );
};

export default TalentCard;
